
export const state = {
    faceLandmarker: null
}

export const mutations = {
    SET_FACE_LANDMARKER(state, faceLandmarker) {
        state.faceLandmarker = faceLandmarker;
    },
}

export const actions = {
    async faceLandmarker({ commit }, faceLandmarker) {
        commit("SET_FACE_LANDMARKER", faceLandmarker);
    },
    async clearFaceLandmarker({ commit }) {
        commit("SET_FACE_LANDMARKER", null);
    }
};

export const getters = {
    faceLandmarker: (state) => state.faceLandmarker,
};

